import React, { VFC, useMemo, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  FormGroup,
} from "@mui/material";
import { useEffect } from "react";
import { Validation } from "@validation";
import LabelRequired from "components/atoms/LabelRequired";
import DatePickerCustom from "components/atoms/DatePickerCustom";
import formatDateToString from "@utils/DateFormat";
import messages from "config/messages";

export interface IHolidayEditData {
  year: string;
  holiday: string;
}

interface IHolidayEditProps {
  data: IHolidayEditData;
  open: boolean;
  onClose: Function;
  onChange: Function;
}

const HolidayEditDialog: VFC<IHolidayEditProps> = ({
  data,
  open,
  onClose,
  onChange,
}: IHolidayEditProps) => {
  // ------------------------------------------------------------------
  // 初期化
  // ------------------------------------------------------------------
  const [holiday, setHoliday] = useState("");
  const [errorText, setErrorText] = useState("");
  const [disabled, setDisabled] = useState(true);
  const minDate = useMemo(() => new Date(data.year + "-01-01"), [data]);
  const maxDate = useMemo(() => new Date(data.year + "-12-31"), [data]);

  useEffect(() => {
    const setInitialData = async () => {
      setHoliday(data.holiday);
      setErrorText("");
      setDisabled(true);
    };

    if (open) {
      setInitialData();
    }
  }, [open, data]);

  // ------------------------------------------------------------------
  // 入力
  // ------------------------------------------------------------------
  const changeHoliday = (value: string | Date | null) => {
    let displayValue = "";
    if (!value) {
      value = "";
    } else {
      value = formatDateToString(value, "YMD");
      displayValue = formatDateToString(value, "YMd");
    }

    let mess = "";
    if (value) {
      mess = Validation.validateDate(value, "祝日", true);
      if (mess.length === 0) {
        // 対象年の範囲内かチェックする
        const currentDate = new Date(value);
        if (minDate > currentDate || currentDate > maxDate) {
          mess = messages.COMMON.ERROR.MSG_DATE_RANGE_LIMIT(data.year + "年");
        }
      }
    }
    setHoliday(displayValue);
    setErrorText(mess);
    setDisabled(mess.length > 0 || data.holiday == displayValue);
  };

  return (
    <Dialog
      maxWidth="sm"
      sx={{ "& .MuiDialog-paper": { width: "80%" } }}
      open={open}
    >
      <DialogContent>
        <FormGroup>
          <DatePickerCustom
            label={<LabelRequired title="祝日" />}
            value={holiday}
            onChange={changeHoliday}
            error={errorText.length > 0}
            helperText={errorText}
            minDate={minDate}
            maxDate={maxDate}
            defaultCalendarMonth={new Date(data.year)}
          />
        </FormGroup>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          onClick={() => {
            onClose();
          }}
          variant="outlined"
        >
          キャンセル
        </Button>

        <Button
          onClick={() => {
            const response: IHolidayEditData = {
              year: data.year,
              holiday: formatDateToString(holiday, "YMD"),
            };
            onChange(response);
            onClose();
          }}
          disabled={disabled}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HolidayEditDialog;
